import '../clan-parallel-game/clan-parallel-game.css';
import { Lock, Swords } from 'lucide-react';
import { GoToClanButton } from '../go-to-clan-button';

const NoClan = () => {
  return (
    <div className="clanParallelGameHeader-container">
      <div className="clanParallelGameHeader-row">
        {/* LEFT */}
        <div className="clanParallelGameHeader-left">
          <div className="clanParallelGameHeader-iconBox clanParallelGameHeader-iconBoxDisabled">
            <Swords className="clanParallelGameHeader-icon" stroke="#9CA3AF" />
          </div>

          <div className="clanParallelGameHeader-text">
            <h2 className="clanParallelGameHeader-title clanParallelGameHeader-titleDisabled">
              Arena del Clan
              <Lock className="clanParallelGameHeader-lock" stroke="#9CA3AF" />
            </h2>

            <p className="clanParallelGameHeader-subtitle clanParallelGameHeader-subtitleDisabled">
              Únete a un clan para desbloquear este modo de juego
            </p>
          </div>
        </div>

        {/* RIGHT */}
        <div className="clanParallelGameHeader-right">
          <GoToClanButton />
        </div>
      </div>
    </div>
  );
};

export default NoClan;
